import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_SIGNATURE_GROWTH_GOOGLE_ONE_TAP_LOGIN_CONFIG = createFcmDetails(
	'signature_growth_google_one_tap_login_config',
	{
		owner: 'Signature Growth',
		context: 'Enable Google’s One-Tap Login',
		import: false,
		description: `
    Set true to enable Google’s One-Tap Login as an A/B testing experiment
    FC should be enabled by:
      - Individual Locales
      - Desktop and Mobile.`,
		template: {
			enabled: false,
			channels: [],
			experiment_name: 'signature_growth_google_one_tap_login_v01',
		},
	},
);
